import { Text, SimpleGrid, Flex, Box, Img } from '@chakra-ui/react'
import Banner from '../../assets/img/services/banner.jpg';
import Phone from '../../assets/img/contact_us/phone.png';
import FormContact from '../contact_us/sections/form';
import ServicesCarousel from './items/carousel';
import InfoServices from './items/info';
import { useTranslation } from 'react-i18next';
import { fontSizesByLang } from '../../helpers/fontSizesByLang';


function ServicesPage() {
    const { t, i18n } = useTranslation();
    const fontSizes = fontSizesByLang[i18n.language];

    return (
        <Flex bg='#1E1D1D' direction={'column'}>

            <Box position="relative" height={{ base: "90vh", md: "80vh", lg: "110vh", xl: "95vh", '2xl': "90vh", }}>

                <Box
                    position="absolute"
                    inset="0"
                    bgImage={`url(${Banner})`}
                    bgSize="cover"
                    bgRepeat="no-repeat"
                    opacity={0.2}
                    zIndex={0}
                    clipPath="inset(0 0 120px 0)"
                    backgroundPosition={{
                        base: "25% 25%",
                        md: "0% 0%"
                    }}
                />



                <Box position="relative" zIndex={1} p={'8%'} w={'100%'}>
                    <SimpleGrid columns={{ base: 1, md: 2 }} gap="10%">
                        <Flex direction={'column'}
                            w={'100%'}
                            mt={{ base: '10%', md: '0%' }}
                        >

                            <Text
                                color={'white'}
                                textTransform="uppercase"
                                fontWeight={'bold'}
                                fontSize={fontSizes.tittlefont}
                                fontFamily={'Roboto Condensed'}
                                letterSpacing={'initial'}
                            >
                                {t("services-tittle1")}
                            </Text>

                            <Text
                                textTransform="uppercase"
                                fontWeight={'bold'}
                                fontSize={fontSizes.tittlefont}
                                fontFamily={'Roboto Condensed'}
                                letterSpacing={'initial'}
                                color={'#AE8245'}
                            >
                                {t("services-tittle1.2")}
                            </Text>

                            <Text color={'#929292'}
                                fontFamily={'Inter'}
                                fontSize={fontSizes.textfont}
                                mb={'5%'}
                                mt={'2%'}
                                w={'75%'}
                            >
                                {t("services-info1")}
                            </Text>

                            <Flex align={'center'} gap={5} fontFamily={'Inter'} mt={'20%'}>
                                <Img src={Phone} width={{base: '10%', md: '6%'}} height={'auto'}/>
                                <Text color={'#AE8245'} fontFamily={'Inter'} fontSize={{ base: '90%', md: '110%' }}>
                                    +1 956 251 6530
                                </Text>
                            </Flex>

                        </Flex>

                    </SimpleGrid>
                </Box>

            </Box>


            <Flex direction={'column'}
                alignItems={'center'} mt={'1%'}>
                <InfoServices />
                <ServicesCarousel />
            </Flex>



            <Flex direction={'column'}
                alignItems={{ base: 'normal', md: 'center' }}
                mt={'2%'}
                p={{ base: '5%', md: '5%', lg: '0%' }}
            >
                <Text
                    color={'white'}
                    textTransform="uppercase"
                    fontWeight={'bold'}
                    fontSize={fontSizes.tittlefont}
                    fontFamily={'Roboto Condensed'}
                    letterSpacing={'initial'}
                >
                    {t("services-tittle4")}
                    <Text as={'span'} color={'#AE8245'} display={{ base: 'none', md: 'inline' }}>
                        {t("services-tittle4.2")}
                    </Text>
                </Text>

                <Text color={'#929292'} fontFamily={'Inter'} fontSize={fontSizes.textfont} fontWeight={'medium'} mb={'5%'} mt={'2%'}>
                    {t("services-info6")}
                </Text>
                <FormContact />
            </Flex>

        </Flex >



    )
}

export default ServicesPage